/* --------------------------------------------------------------------------------------
   xwBanner.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwBanner {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {
        onClose: '&'
    }
  }
  link(scope, elem, attrs) {
    const options = {
      bannerType: attrs.bannerType,
      bannerTimeout: attrs.bannerTimeout,
      close: (event, ui) => {scope.onClose()}
    }
    elem.first().xrxbanner(options)

    attrs.$observe('display', (val) => {
      if (val == 'true')
        elem.first().xrxbanner('call')
      if (val == 'false')
        elem.first().xrxbanner('close')
    });

    scope.$on('$destroy', () => {
      scope = null
    })
    elem.on('$destroy', () => {
      elem.first().xrxbanner('destroy')
      elem = null
    })
  }
  static directiveFactory() {
    xwBanner.instance = new xwBanner()
    return xwBanner.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwBanner.directive.js